/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type GetClusterOrgAuthClusterResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class GetClusterOrgAuthClusterResponse429ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetClusterOrgAuthClusterResponse429ResponseBodyData;

  constructor(
    err: GetClusterOrgAuthClusterResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetClusterOrgAuthClusterResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type GetClusterOrgAuthClusterResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class GetClusterOrgAuthClusterResponse409ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetClusterOrgAuthClusterResponse409ResponseBodyData;

  constructor(
    err: GetClusterOrgAuthClusterResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetClusterOrgAuthClusterResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type GetClusterOrgAuthClusterResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class GetClusterOrgAuthClusterResponse404ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetClusterOrgAuthClusterResponse404ResponseBodyData;

  constructor(
    err: GetClusterOrgAuthClusterResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetClusterOrgAuthClusterResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type GetClusterOrgAuthClusterResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class GetClusterOrgAuthClusterResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetClusterOrgAuthClusterResponseResponseBodyData;

  constructor(
    err: GetClusterOrgAuthClusterResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetClusterOrgAuthClusterResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type GetClusterOrgAuthClusterResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class GetClusterOrgAuthClusterResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetClusterOrgAuthClusterResponseBodyData;

  constructor(
    err: GetClusterOrgAuthClusterResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetClusterOrgAuthClusterResponseBody";
  }
}

/**
 * Bad request
 */
export type GetClusterOrgResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class GetClusterOrgResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetClusterOrgResponseBodyData;

  constructor(
    err: GetClusterOrgResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetClusterOrgResponseBody";
  }
}

/** @internal */
export const GetClusterOrgAuthClusterResponse429ResponseBody$inboundSchema:
  z.ZodType<
    GetClusterOrgAuthClusterResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetClusterOrgAuthClusterResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetClusterOrgAuthClusterResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetClusterOrgAuthClusterResponse429ResponseBody$outboundSchema:
  z.ZodType<
    GetClusterOrgAuthClusterResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    GetClusterOrgAuthClusterResponse429ResponseBody
  > = z.instanceof(GetClusterOrgAuthClusterResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetClusterOrgAuthClusterResponse409ResponseBody$inboundSchema:
  z.ZodType<
    GetClusterOrgAuthClusterResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetClusterOrgAuthClusterResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetClusterOrgAuthClusterResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetClusterOrgAuthClusterResponse409ResponseBody$outboundSchema:
  z.ZodType<
    GetClusterOrgAuthClusterResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    GetClusterOrgAuthClusterResponse409ResponseBody
  > = z.instanceof(GetClusterOrgAuthClusterResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetClusterOrgAuthClusterResponse404ResponseBody$inboundSchema:
  z.ZodType<
    GetClusterOrgAuthClusterResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetClusterOrgAuthClusterResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetClusterOrgAuthClusterResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetClusterOrgAuthClusterResponse404ResponseBody$outboundSchema:
  z.ZodType<
    GetClusterOrgAuthClusterResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    GetClusterOrgAuthClusterResponse404ResponseBody
  > = z.instanceof(GetClusterOrgAuthClusterResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetClusterOrgAuthClusterResponseResponseBody$inboundSchema:
  z.ZodType<
    GetClusterOrgAuthClusterResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetClusterOrgAuthClusterResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetClusterOrgAuthClusterResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetClusterOrgAuthClusterResponseResponseBody$outboundSchema:
  z.ZodType<
    GetClusterOrgAuthClusterResponseResponseBody$Outbound,
    z.ZodTypeDef,
    GetClusterOrgAuthClusterResponseResponseBody
  > = z.instanceof(GetClusterOrgAuthClusterResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetClusterOrgAuthClusterResponseBody$inboundSchema: z.ZodType<
  GetClusterOrgAuthClusterResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetClusterOrgAuthClusterResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetClusterOrgAuthClusterResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetClusterOrgAuthClusterResponseBody$outboundSchema: z.ZodType<
  GetClusterOrgAuthClusterResponseBody$Outbound,
  z.ZodTypeDef,
  GetClusterOrgAuthClusterResponseBody
> = z.instanceof(GetClusterOrgAuthClusterResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const GetClusterOrgResponseBody$inboundSchema: z.ZodType<
  GetClusterOrgResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetClusterOrgResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetClusterOrgResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetClusterOrgResponseBody$outboundSchema: z.ZodType<
  GetClusterOrgResponseBody$Outbound,
  z.ZodTypeDef,
  GetClusterOrgResponseBody
> = z.instanceof(GetClusterOrgResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
